const filterMyPatients = (patients, myPatientIds, isShowingMyPatients) => {
  if (!isShowingMyPatients) return patients;

  const myPatientIdSet = new Set(myPatientIds);

  return patients.filter((patient) => myPatientIdSet.has(patient.id));
};

export default filterMyPatients;
